import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-background">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <p className="font-heading font-bold text-8xl text-primary-100 select-none">404</p>
          <div className="-mt-6">
            <h1 className="font-heading font-bold text-2xl text-gray-800 mb-2">Page Not Found</h1>
            <p className="text-gray-500">The page you're looking for doesn't exist or has been moved.</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild>
            <Link to="/"><Home className="h-4 w-4 mr-2" />Go Home</Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/search"><Search className="h-4 w-4 mr-2" />Search Products</Link>
          </Button>
        </div>

        <button
          onClick={() => window.history.back()}
          className="mt-6 flex items-center gap-1.5 text-sm text-gray-400 hover:text-gray-600 mx-auto"
        >
          <ArrowLeft className="h-4 w-4" /> Go back
        </button>
      </div>
    </div>
  );
};
